import User from './currentUser';
import { removeATACookie } from './setOrganizationCookies';
import { saveUrlForRedirect } from '../login/helper/urlHandler';
import { clearUserData } from './clearUserData';

const user = new User();

function redirect(reason, endpoint, logoutObj) {
  if (!logoutObj.dontSaveUrlForRedirect) {
    saveUrlForRedirect(window.location.href);
  }
  window.location.href = `${endpoint}?r=${reason}`;
  if (window.location.hash) {
    window.location.reload(true);
  }
}

export default async function handleLogout(
  reason = 'logout',
  endpoint = '/#/login',
  logoutObj = {}
) {
  try {
    console.log('handle logout called, reason', reason, 'endpoint', endpoint);

    window.analytics &&
      window.analytics.track('Handle_logout_called', {
        type: 'handle_logout_called',
        message: 'handle_logout_called',
        reason,
        endpoint,
        userId: user.id(),
        accessToken: user.aToken() || '',
        loginMode: user.loginMode() || 'notSet'
      });

    const userId = user.id();

    if (userId) {
      removeATACookie(userId);
    }

    await clearUserData();
  } catch (e) {
    console.error('error in handle logout', e);
    window.bugsnagClient && window.bugsnagClient.notify(e);
  } finally {
    window.sprChat && window.sprChat('clearSession');
    setTimeout(() => redirect(reason, endpoint, logoutObj), 400);
  }
}
